var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('ScanOrderInfo',{attrs:{"visible":_vm.showScanInfo,"scanOrderInfo":_vm.scanMsg},on:{"onClose":_vm.hideScanInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }